module.exports = __webpack_public_path__ + "img/jenkins.260009e3.png";